import {
  useMutation,
  type UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  deleteApiV2CustomersCustomerIdPairingRatingsPairingId,
  type DeleteCustomerPairingRatingDetailParams,
} from '@hungryroot/rest/api/v2/customers/[id]/pairing_ratings/[pairing_id]/delete';
import { getCustomerPairingRatingsQueryKey } from './useCustomerPairingRatings';

type UseDeleteCustomerPairingRatingsProps<Context> = Omit<
  UseMutationOptions<
    void,
    Error,
    DeleteCustomerPairingRatingDetailParams,
    Context
  >,
  'mutationFn'
>;

export function useDeleteCustomerPairingRating<Context>(
  props?: UseDeleteCustomerPairingRatingsProps<Context>
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: DeleteCustomerPairingRatingDetailParams) => {
      const res =
        await deleteApiV2CustomersCustomerIdPairingRatingsPairingId(params);

      if (res.status !== StatusCode.SuccessNoContent) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }

      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getCustomerPairingRatingsQueryKey(),
      });
    },
    ...props,
  });
}
